/* Copyright Flexday Solutions LLC, Inc - All Rights Reserved

 * Unauthorized copying of this file, via any medium is strictly prohibited

 * Proprietary and confidential

 * See file LICENSE.txt for full license details.

 */

const muiButton = {
  styleOverrides: {
    containedSizeLarge: {
      padding: '6px 36px',
    },
    contained: ({ theme }) => ({
      backgroundColor: theme.palette.secondary.main,
    }),
    outlinedSizeLarge: ({ theme }) => ({
      padding: '6px 12px',
      color: theme.palette.text.controls,
    }),
    outlinedSizeSmall: ({ theme }) => ({
      padding: '0px 16px',
      color: theme.palette.text.controls,
    }),
    sizeSmall: ({ theme }) => ({
      fontSize: '1rem',
      lineHeight: theme.typography.pxToRem(15),
      borderRadius: theme.spacing(1),
      minHeight: '29px',
    }),
    sizeMedium: ({ theme }) => ({
      fontSize: '1rem',
      lineHeight: theme.typography.pxToRem(18),
      borderRadius: theme.spacing(1),
      minHeight: '33px',
    }),
    sizeLarge: ({ theme }) => ({
      fontSize: '1rem',
      lineHeight: theme.typography.pxToRem(21),
      borderRadius: theme.spacing(1),
      minHeight: '38px',
    }),
    endIcon: ({ theme }) => ({
      '& > :nth-of-type(1)': {
        fontSize: theme.typography.pxToRem(24),
        color: theme.palette.primary.main,
      },
    }),
  },
};

export { muiButton };
